import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-cached',
    templateUrl: './cached.component.svg',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CachedComponent {}
